module.exports = __webpack_public_path__ + "img/0x78e1330db47634afdb5ea455302ba2d12b8d549f.3b1e7d92.png";